module.exports = __webpack_public_path__ + "static/blendingAlt-3db6e3842e4ca121c99512eff3e6e7d8.jpg";